import './vendor';
import spFrontPanelEditor from "./SPFrontPanelEditor";

import "./style/less/xly.less";
import "./style/less/dashboard.less";

import loadConfiguration from './configuration';
import loadBlocks from './blocks';
import loadFeatures from './feature';
import loadFix from './fix';

import _ from "underscore";

const grapesjs = spFrontPanelEditor.grapesjs;

// 加载配置
loadConfiguration(grapesjs);

// 加载 blocks
loadBlocks(grapesjs);

// 加载 features
loadFeatures(grapesjs);

// 加载 fix
loadFix(grapesjs);

export default spFrontPanelEditor;